import React from 'react';
import { IonPage } from '@ionic/react';
import { Redirect } from 'react-router-dom';
import { useAppConfig } from '@/modules/config';
import { topicGardenEnabled } from '@/conditional_feature/topic_garden_enabled';
import TopicView from './TopicView';
import { requestTypePickerOnEnter } from './Topics';

/**
 * Create-mode route (`/topics/new`). With the garden flag on, the type picker is a
 * sheet over the topics list, so this route asks the list to open the sheet and
 * redirects to `/topics`; picking a type there routes
 * to that type's create form at `/topics/new-<type>` (see `TopicCreateForType`).
 * With the flag off, fall back to the legacy `TopicView` (which chooses type via
 * inline chips on this same route).
 *
 * Until config has loaded, `features` is `{}` and which of the two applies is
 * unknown, so it renders an empty page rather than briefly showing the legacy form.
 * That placeholder is an `IonPage`, not a `<Redirect>`, for the outlet reason
 * `TopicCreateForType` describes.
 */
const CreateTopicGate: React.FC = () => {
  const { features, isLoaded } = useAppConfig();
  if (!isLoaded) {
    return <IonPage />;
  }
  if (!topicGardenEnabled(features)) {
    return <TopicView initialMode="create" />;
  }
  requestTypePickerOnEnter();
  return <Redirect to="/topics" />;
};

export default CreateTopicGate;
